<template>
    <div
        class="max-w-[900px] border-box w-full left-[50%] translate-x-[-50%] px-4 md:px-6 fixed bottom-[24px] z-50">
        <output
            aria-live="assertive"
            :class="[
                statusState.display === 'none' ? 'hidden' : 'block',
                statusClass,
                'border px-4 py-3 rounded block md:w-auto; w-full relative pr-12',
            ]"
            role="alert">
            <button
                @click="clearNotice()"
                class="absolute top-3 right-3 tr"
                aria-label="Close notification">
                <svg
                    class="h-6 w-6 fill-inherit"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    aria-hidden="true"
                    focusable="false">
                    <path
                        d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                </svg>
            </button>
            <div class="flex flex-row justify-start align-top">
                <div
                    class="w-4 mr-4 md:mr-6"
                    v-if="statusStore.status">
                    <Icon
                        :icon="statusStore.status"
                        :alt="statusStore.status" />
                </div>
                <div class="flex flex-col justify-start align-top">
                    <div
                        class="inline"
                        v-html="statusStore.copy"></div>

                    <button
                        v-if="errorState.refresh_required"
                        @click="refreshAvailability()"
                        class="font-bold mt-2 block text-left">
                        Click here to reselect
                    </button>
                </div>
            </div>
        </output>
    </div>
</template>
<script setup>
    import { useStatusStore } from '@/stores/status';
    import { useErrorStore } from '@/stores/error';
    import { refreshAvailability } from '@/helpers/fetchData';

    const { state: errorState } = useErrorStore();

    const statusStore = useStatusStore();
    const statusState = computed(() => statusStore.$state);

    const clearNotice = () => {
        statusStore.clearStatus();
    };

    const statusClass = computed(() => {
        switch (statusState.value.status) {
            case 'alert':
                return 'border-[#414141] text-white bg-[#414141] fill-[#414141]';
            case 'success':
                return 'border-green-400 text-green-700 bg-green-100 fill-green-500';
            case 'warning':
                return 'border-red-400 text-red-700 bg-red-100  fill-red-500';
            // Add more cases as needed
            default:
                return 'border-[#414141] text-white bg-[#414141] fill-[#414141]';
        }
    });
</script>
